import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=ee913cd0&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=ee913cd0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee913cd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee913cd0')) {
      api.createRecord('ee913cd0', component.options)
    } else {
      api.reload('ee913cd0', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=ee913cd0&scoped=true", function () {
      api.rerender('ee913cd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/ui-components/pcfooter/Form.vue"
export default component.exports